// extracted by mini-css-extract-plugin
export default {"pageContent":"menuPage_pageContent__XmUVH","content":"menuPage_content__23-Gd"};